import request from '@/axios';

export const getTree = (current, size, params) => {
  return request({
    url: '/emp-business/blade-report/group/tree',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const remove = ids => {
  return request({
    url: '/emp-business/blade-report/group/removeReportGroup',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const save = row => {
  return request({
    url: '/emp-business/blade-report/group/save',
    method: 'post',
    data: row,
  });
};

export const update = row => {
  return request({
    url: '/emp-business/blade-report/group/update',
    method: 'post',
    data: row,
  });
};